export class CitationSearchParams {
    public citationNumber: string | null = null;
    public lotId: string | null = null;
    public officerId: string | null = null;
    public violationCode: string | null = null;
    public startDate: Date | null = null;
    public endDate: Date | null = null;
    public plateNumber: string | null = null;
    public exactPlateMatch: boolean = false;
    public vehicleState: string | null = null;
    public driversLicense: string | null = null;
    public vin: string | null = null;
    public firstName: string | null = null;
    public lastName: string | null = null;
    public middleName: string | null = null;
    public address1: string | null = null;
    public address2: string | null = null;
    public city: string | null = null;
    public customerState: string | null = null;
    public zip: string | null = null;
    public homephone: string | null = null;
    public workphone: string | null = null;
    public cellphone: string | null = null;
    public email: string | null = null;
    public badAddress: boolean = false;
    public unpaidOnly: boolean = false;
    public commentsOnly: boolean = false;
    public photosOnly: boolean = false;
}
